/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Roles_1Inputs */

const da_privacy_roles_1 = /** @type {(inputs: Privacy_Roles_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For **dine oplysninger som bruger** (lærer, skoleleder eller kunde) er vi dataansvarlige. Det er dem, denne politik handler om.`)
};

/** @type {(inputs: Privacy_Roles_1Inputs) => LocalizedString} */
const en_privacy_roles_1 = da_privacy_roles_1;

/**

* @param {Privacy_Roles_1Inputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const privacy_roles_1 = /** @type {((inputs?: Privacy_Roles_1Inputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Roles_1Inputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_roles_1(inputs)
	return /** @type {LocalizedString} */ ("For **dine oplysninger som bruger** (lærer, skoleleder eller kunde) er vi dataansvarlige. Det er dem, denne politik handler om.")
});